<template>
    <v-btn v-if="!isGuest"
           @click="applyGradeFrom(currentFile)"
           :disabled="!canUseColorGradingTools || blockLoading || !image || IDT.initial"
           v-tippy
           content="Apply Grade From..."
    >
        <v-icon class="material-icons">perm_media</v-icon>
    </v-btn>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import FilenameMixin from "@/mixins/Filename";
import { mapGetters, mapState } from "vuex";

export default {
    mixins: [CanMixin, FilenameMixin],
    data() {
        return {
            initial: true
        }
    },
    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("Projects", ['image', 'currentFile']),
        ...mapGetters('Projects', ['isCurrentFileShared']),
        ...mapGetters('User', ['isGuest']),
    },
    methods: {
        applyGradeFrom(file) {
            if (file.type == 'candidate' && file.parent_file) file = file.parent_file;

            this.$store.dispatch("Projects/setAction", {
                type: file.type,
                action: "applyGradeFrom",
                id: file.id,
                data: [file],
            });

            this.$store.dispatch("Projects/setApplyGradeFromCandidateProjectTree");
            this.$store.dispatch("Projects/setApplyGradeFromMatchProjectTree");

            window.UI.showModal(window.UI.modals.grade.applyFrom);

            if (this.initial) {
                // v-tab active fix
                document.querySelectorAll("#apply-grade-from-modal .v-tab")[1].click();
                setTimeout(() => document.querySelectorAll("#apply-grade-from-modal .v-tab")[0].click(), 10);
                this.initial = false;
            }
        },
    }
}
</script>